import classNames from "classnames";
import classes from "./classes.module.scss";
import Typography from "components/elements/Typography";
import { TMenuItem } from "..";

type IProps = {
	menuItem: TMenuItem;
	active?: boolean;
	disabled?: boolean;
	onClick: () => void;
};

export default function MenuItem(props: IProps) {
	const onClick = () => {
		if (props.disabled) return;
		props.onClick();
	};

	return (
		<div
			className={classNames(classes["root"], {
				[classes["active"]!]: props.active,
				[classes["disabled"]!]: props.disabled,
			})}
			onClick={onClick}>
			{props.menuItem.icon}
			<Typography type="p" size="medium" weight="regular" className={classes["label"]}>
				{props.menuItem.label}
			</Typography>
		</div>
	);
}
